if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.infoContainer = this.closest('.product__info-container');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.handleQtyUpdate();
      this.addBogoItems();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.addMulberryWarranty();
          this.klaviyoTrack();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async addMulberryWarranty() {
      if (window.mulberry?.inline?.instance?.selectedWarranty?.isSelected) {
        const warranty = window.mulberry.inline.instance.selectedWarranty;
        const { shopify_variant_id } = await mulberryShop.getWarrantyVariant(warranty);
        mulberryShop.addWarrantyToCart(shopify_variant_id, warranty);
      }
    }

    klaviyoTrack() {
      const _learnq = window._learnq || [];
      fetch(`/cart.js`)
        .then(res => res.clone().json().then(data => {
          var cart = {
            total_price: data.total_price / 100,
            $value: data.total_price / 100,
            total_discount: data.total_discount,
            original_total_price: data.original_total_price / 100,
            items: data.items
          }
          _learnq.push(['track', 'Added to Cart', cart])
        }))
    }

    handleQtyUpdate() {
      if (!this.infoContainer) return
      const qtyInput = this.infoContainer.querySelector('.product-form__input .quantity__input');
      if (!qtyInput) return;
      qtyInput.addEventListener('change', () => {
        this.updateTotalPrice();
        const bogoInput = this.querySelector('.bogo-input-qty')
        if (!bogoInput) return
        bogoInput.value = qtyInput.value
      });
    }

    updateTotalPrice() {
      if (!this.infoContainer || this.closest('additional-item')) return
      const addButton = this.infoContainer.querySelector('[name="add"]:not([disabled])');
      if (!addButton) return;
      let addToCartLabel = window.variantStrings.addToCart;
      const priceEl = this.infoContainer.querySelector('.price .price-item--last');
      if (priceEl) {
        addToCartLabel = `<span><span class="product-form__submit__price"></span> ${window.variantStrings.addToCart}</span>`;
        const currentPrice = parseFloat(priceEl.innerText.trim().replace('$', '').replace('.', ''));
        let mainQty = 1
        const qtyInput = this.infoContainer.querySelector('.product-form__input .quantity__input')        
        if (qtyInput) {
          mainQty = parseInt(qtyInput.value)
        }
        let totalPrice = currentPrice * mainQty;
        if (window.mulberry?.inline?.instance?.selectedWarranty?.isSelected) {
            totalPrice += parseFloat(window.mulberry.inline.instance.selectedWarranty.customer_cost.toString().replace('.', ''));
        }
        Array.from(this.infoContainer.querySelectorAll('.additional-item-added')).forEach((addedBtn) => {
          const additionalItemEl = addedBtn.closest('additional-item')
          const price = parseFloat(additionalItemEl.querySelector('.additional-item__price').innerText.trim())
          const qty = parseFloat(additionalItemEl.querySelector('.quantity__input').value)
          const additionalItemPrice = (price * qty).toFixed(2)
          totalPrice += parseFloat(additionalItemPrice.toString().replace('.', ''))
        })
        addToCartLabel = `<span>Total: <span class="product-form__submit__price">${Shopify.formatMoney(totalPrice)}</span> – ${window.variantStrings.addToCart}</span>`;
      }
      addButton.querySelector('span').innerHTML = addToCartLabel;
    }
    
    addBogoItems() {
      window.addEventListener('load', () => {
        const bogoEl = document.querySelector('#bogo-json')
        const mainProductId = parseFloat(this.dataset.productId)
        if (!bogoEl || !mainProductId) return
        const bogoJson = JSON.parse(bogoEl.textContent)
        const bogo = bogoJson.find((bogo) => parseInt(bogo.buy_product_id) === mainProductId)
        if (!bogo) return
        if (this.querySelector('.bogo-input')) return
        let qty = 1
        const qtyInput = this.infoContainer.querySelector('.product-form__input .quantity__input');
        if (qtyInput) {
          qty = qtyInput.value
        }
        this.form.insertAdjacentHTML(`afterbegin`, `
          <input type="hidden" name="items[999]id" value="${bogo.get_variant_id}" class="bogo-input">
          <input type="hidden" name="items[999]quantity" value="${qty}" class="bogo-input-qty">
        `)
      });      
    }
  });
}
